import React, { useState, useRef, useEffect } from 'react';
import { FaBell, FaUser, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { FiRefreshCw, FiMenu } from 'react-icons/fi';
import { BsGrid3X3Gap } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import styles from '../../../src/assets/scss/Header.module.scss';
import { getUserInfo } from '../../utils/user.util';
import { BaseURL } from '../../lib/api';
import dummyProfile from "../../assets/images/Profile.png";
import { adminApi, useGetUnreadCountQuery, useGetUserByIdQuery, useLogoutUserMutation } from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import DeleteConfirmModalLogout from '../Common/DeleteConfirmModalLogout';
import { useDispatch } from 'react-redux';
import Lng from '../../Lng/Lng';

const Header = ({ toggleSidebar }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [userData, setUserData] = useState(null);
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const localUser = getUserInfo();
  const userId = localUser?._id;

  const { data: unreadCount, isLoading } = useGetUnreadCountQuery();
  const { data, refetch } = useGetUserByIdQuery(userId, { skip: !userId });

  //console.log(data,"header user data");

  const [logoutUser] = useLogoutUserMutation();

  useEffect(() => {
    if (data?.result) setUserData(data.result[0]);
  }, [data]);

  useEffect(() => {
    const handleProfileUpdated = (e) => {
      if (e?.detail) setUserData(e.detail);
      else refetch();
    };
    window.addEventListener('user-profile-updated', handleProfileUpdated);
    return () => window.removeEventListener('user-profile-updated', handleProfileUpdated);
  }, [refetch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
        setShowMenuDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      const res = await logoutUser().unwrap();
      toast.success(res.message || "Logout successful");
      const appLanguage = localStorage.getItem("appLanguage");
      localStorage.clear();
      sessionStorage.clear();
      if (appLanguage) {
        localStorage.setItem("appLanguage", appLanguage);
      }
      dispatch(adminApi.util.resetApiState());
      navigate('/login');
    } catch (err) {
      toast.error(err?.data?.message || "Logout failed");
    }
  };

  const fullName = `${userData?.firstName || ''} ${userData?.lastName || ''}`;
  // const avatarUrl = userData?.profile ? `${BaseURL}/${userData.profile}` : dummyProfile;
  // const avatarUrl1 = userData?.store?.logo ? `${BaseURL}/${userData.store?.logo}` : "";
  const avatarUrl =
    userData?.profile
      ? userData.profile.startsWith("http")
        ? userData.profile
        : `${BaseURL}/${userData.profile}`
      : dummyProfile;

  const avatarUrl1 =
    userData?.store?.logo
      ? userData.store.logo.startsWith("http")
        ? userData.store.logo
        : `${BaseURL}/${userData.store.logo}`
      : "";

  const roleName = userData?.type || 'User';

  // Menu dropdown functionalities
  const user = getUserInfo();
  const functionalitySet = new Set();
  user?.roles?.forEach(role => {
    role?.permissions?.forEach(permission => {
      if (permission?.isActive && permission?.functionality) functionalitySet.add(permission.functionality);
    });
  });

  const DROPDOWN_FUNCTIONALITIES = [
    { key: 'invite', label: 'Invite', path: '/dashboard/Invite' },
    // { key: 'subscriptionAdmin', label: 'Subscription Admin', path: '/dashboard/SubscriptionAdmin' },
    { key: 'subscriptionUsers', label: 'My Subscription', path: '/dashboard/SubscriptionUser' },
  ];

  const handleMenuNavigate = (path) => {
    setShowMenuDropdown(false);
    navigate(path);
  }




  return (
    <>
      <div className={styles.header}>
        {/* Left: Sidebar toggle + Store Logo/Info */}
        <div className={styles.mainheader}>
          {/* <BsGrid3X3Gap onClick={toggleSidebar} className={styles.icon} /> */}
          {avatarUrl1 && <img src={avatarUrl1} alt="store logo" className={styles.dropdownAvatarhead} />}
          <div className={styles.leftInfo}>
            <h4 className={styles.prohead}>{userData?.store?.storeName || 'Store Name'}</h4>
            <p className={styles.prosub}>{userData?.store?.address1 || 'Store Address'}</p>
            <p className={styles.prosub}>{userData?.store?.address2 || ''}</p>
          </div>
        </div>

        {/* Right: Refresh + Notifications + Menu + Profile */}
        <div className={styles.rightInfo} ref={dropdownRef}>
          <div className={styles.lngFixed} >
            <Lng />
          </div>


          <div className={styles.notification} onClick={() => navigate("/dashboard/Notifications")}>
            <FaBell />
            {!isLoading && unreadCount > 0 && <span className={styles.badge}>{unreadCount}</span>}
          </div>

          <div className={styles.profile} onClick={() => setIsProfileOpen(prev => !prev)}>
            <div className={styles.containimg}>
              <img src={avatarUrl} alt="profile" className={styles.avatar} />
            </div>
            <div>
              <h5 className={styles.profileHead}>{fullName}</h5>
              <span className={styles.block}>{roleName}</span>
            </div>
          </div>

          {isProfileOpen && (
            <div className={styles.profileDropdown}>
              <div className={styles.profileHeader}>
                <img src={avatarUrl} alt="profile" className={styles.dropdownAvatar} />
                <div>
                  <h5 className={styles.profileHead}>{fullName}</h5>
                  <span>{roleName}</span>
                </div>
              </div>
              <div className={styles.profileOptions}>
                <div onClick={() => { navigate('/dashboard/Profile'); setIsProfileOpen(false); }} className={styles.option}>
                  <FaUser /> My Profile
                </div>
                <div onClick={() => { navigate('/dashboard/Settings'); setIsProfileOpen(false); }} className={styles.option}>
                  <FaCog />Language Settings
                </div>
                <hr className={styles.divider} />
                <div onClick={() => setLogoutModalOpen(true)} className={styles.logout}>
                  <FaSignOutAlt /> Logout
                </div>
              </div>
            </div>
          )}
          <div className={styles.iconContainer} onClick={() => window.location.reload()}>
            <FiRefreshCw className={styles.icons} />
          </div>
          {DROPDOWN_FUNCTIONALITIES.some(item => functionalitySet.has(item.key)) && (
            <div className={styles.dropdownWrapper}>
              <FiMenu
                onClick={() => setShowMenuDropdown(prev => !prev)}
                className={styles.icon}
              />
              {showMenuDropdown && (
                <div className={styles.dropdownMenu}>
                  {DROPDOWN_FUNCTIONALITIES.map(
                    ({ key, label, path }) =>
                      functionalitySet.has(key) && (
                        <div
                          key={key}
                          className={styles.dropdownItem}
                          onClick={() => handleMenuNavigate(path)}
                        >
                          {label}
                        </div>
                      )
                  )}
                </div>
              )}
            </div>
          )}

        </div>
      </div>

      <DeleteConfirmModalLogout
        isOpen={logoutModalOpen}
        onConfirm={handleLogout}
        onCancel={() => setLogoutModalOpen(false)}
        title="Are you sure?"
        heading="Logout Confirmation"
        content="You want to logout from your account? You will need to log in again to access the system."
      />
    </>
  );
};

export default Header;

